import axios from 'axios';

// Sem REACT_APP_API_URL (desenvolvimento), a API é chamada no mesmo host em
// que a página foi aberta, na porta 3030: funciona tanto em localhost quanto
// pelo IP da rede (celular), mesmo que o roteador troque o IP do computador.
// Em produção REACT_APP_API_URL é sempre definida no build.
const defaultApiUrl = () => {
  if (typeof window === 'undefined' || !window.location?.hostname) return 'http://localhost:3030/api';
  return `${window.location.protocol}//${window.location.hostname}:3030/api`;
};

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || defaultApiUrl(),
});

// Injeta o token JWT em todas as requisições
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  // Empresa ativa (só relevante para admin de matriz com filiais e para o
  // superadmin) — ver CompanySwitcher.js. O backend ignora esse header para
  // qualquer usuário cujo conjunto de empresas acessíveis tenha só 1 item.
  // Uma chamada pode enviar explicitamente `X-Active-Company-Id: ''` pra
  // pedir a lista completa sem o filtro da empresa ativa (ex.: o próprio
  // CompanySwitcher populando suas opções) — nesse caso não sobrescrevemos.
  const activeCompanyId = localStorage.getItem('activeCompanyId');
  if (activeCompanyId && config.headers['X-Active-Company-Id'] === undefined) {
    config.headers['X-Active-Company-Id'] = activeCompanyId;
  }

  return config;
});

// Redireciona para login se o token expirar
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Não redireciona se for falha de login (rota pública)
      if (!error.config.url.includes('/auth/login') && !error.config.url.includes('/auth/verify-2fa')) {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        window.location.href = '/';
      }
    }
    return Promise.reject(error);
  }
);

export default api;
